import { DashboardNavigationDataModel } from "../models/dashboard-navigation.models";
import { DashboardResponsiveApiModelSparse } from "../models/dashboard.model";
import { ClearViewUtils } from "../utils";
import { CvApiServiceBase } from "./cv-api-service-base";
import { CvLocalizationServiceBase } from "./cv-localization-service-base";
import { DashboardServiceBase } from "./dashboard-service-base";

export class DashboardNavigationServiceBase {
    pageGroupID = 9;
    isLoading = true;
    hasOwnLegacyDashboard = false;
    userDashboardGroups = null;
    sharedDashboardGroups = null;
    userExpanded = true;
    sharedExpanded = true;
    userWorkspaceKey = '';
    dashboards = null;
    hasWorkspace = false;

    openMigrateModal: () => void; // replaced by AngularJS service until migrated

    protected dataObj: DashboardNavigationServiceBase = this; // for old JS stuff

    constructor(
        fromSharedService: boolean = false,
        private cvApiService?: CvApiServiceBase,
        private cvLocalizationService?: CvLocalizationServiceBase,
        private dashboardService?: DashboardServiceBase,
    ) {
        if (fromSharedService)
            return DashboardNavigationServiceBase.getServiceBase();

        if (!cvApiService)
            this.cvApiService = CvApiServiceBase.getServiceBase();

        if (!cvLocalizationService)
            this.cvLocalizationService = CvLocalizationServiceBase.getServiceBase();

        if (!dashboardService)
            this.dashboardService = DashboardServiceBase.getServiceBase();

        this.initialize();
    }

    static getServiceBase(): DashboardNavigationServiceBase {
        return ClearViewUtils.getSharedService(DashboardNavigationServiceBase, 'DashboardNavigationServiceBase');
    }

    async initialize() {
        this.getUserWorkspaceKey();
        this.cvLocalizationService.GetSection("Left_Nav_Popup");
        this.getExpandedState('legacy-shared').then(result => this.sharedExpanded = (result.data !== false));
        this.getExpandedState('legacy-user').then(result => this.userExpanded = (result.data !== false));
    }

    async migrateDashboard(dashboardId: number) {
        const result = await this.cvApiService.post<DashboardResponsiveApiModelSparse>(`/api/v1/dashboards/${dashboardId}/migrate`);
        this.dashboardService.availableDashboards.push(result.data);
        if (!this.dashboardService.dashboardGroups.includes(result.data.DashboardGroup)) {
            this.dashboardService.dashboardGroups.push(result.data.DashboardGroup);
            this.dashboardService.dashboardGroups.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        }
        return result;
    }

    async getUserWorkspaceKey() {
        const result = await this.cvApiService.get<string>('/api/v2/userWorkspaceKey');
        if (result.status_code === 200)
            this.userWorkspaceKey = result.data;
        return result;
    }

    loadDashboards() {
        return this.cvApiService.get<DashboardNavigationDataModel>('/api/v1/navigation/dashboardList');
    }

    setExpandedState(key: string, state: boolean) {
        return this.cvApiService.post(`/api/v1/navigation/expanderState/${key}/${state}`);
    }

    getExpandedState(key: string) {
        return this.cvApiService.get<boolean>(`/api/v1/navigation/expanderState/${key}`);
    }

    navigateToDashboardView() {
        const workspacePageUri = _BaseURI + "/Dashboard/DashboardNew.aspx";
        // If we are not on dashboard page
        if (window.location.href.indexOf(workspacePageUri) === -1) {
            window.location.href = workspacePageUri; // Go to dashboard page
            return true;
        }

        return false;
    }

    navigateToCXOneDashboardView() {
        sendMessageCXOne({dashboardSelected: true});
        const workspacePageUri = _BaseURI + "/Dashboard/launch_cxone_dash.aspx";
        if (window.location.href.indexOf(workspacePageUri) === -1) {
            window.location.href = workspacePageUri; // Go to cxone dashboard page
            return true;
        }

        return false;
    }

    navigateToCXOneDashboardManagement() {
        const managementPageUri = _BaseURI + "/dashboard/CXOneManageDashboards.aspx";
        if (window.location.href.indexOf(managementPageUri) === -1) {
            window.location.href = managementPageUri;
            return true;
        }

        return false;
    }
}
